import type { SceneAsset, SceneInformation } from "randmar-api-client";

export class Scene {
  public name?: string;
  public scene?: MediaFile;
  public thumbnail?: MediaFile;
  public preview?: MediaFile;

  constructor(source?: SceneInformation) {
    if (source) {
      this.name = source.Name ?? undefined;
      if (source.Scene)
        this.scene = MediaFile.convertFrom(source.Scene);
      if (source.Thumbnail)
        this.thumbnail = MediaFile.convertFrom(source.Thumbnail);
      if (source.Preview)
        this.preview = MediaFile.convertFrom(source.Preview);
    }
  }

  public static convertFrom(source: SceneInformation): Scene {
    return new Scene(source)
  }
}

export class MediaFile {
  public fileName?: string;
  public fileType?: string;
  public creationDate?: string;
  public description?: string;
  public contentLength?: number;
  public contentType?: string;

  constructor(source?: SceneAsset) {
    if (source) {
      this.fileName = source.FileName ?? undefined;
      this.fileType = source.FileType ?? undefined;
      this.creationDate = source.CreationDate;
      this.description = source.Description ?? undefined;
      this.contentLength = source.ContentLength;
      this.contentType = source.ContentType ?? undefined;
    }
  }

  public static convertFrom(source: SceneAsset): MediaFile {
    return new MediaFile(source)
  }
}
